import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/partner")({
  head: () => ({ meta: [{ title: "Partner API | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-partner")),
});
